export const COMPANY_AMENITIES = ['Wi-Fi', 'Estacionamento', 'Acessibilidade', 'Ar-condicionado'] as const;
export const COMPANY_PAYMENT_METHODS = ['Pix', 'Cartão de crédito', 'Cartão de débito', 'Dinheiro'] as const;

/** Manual links only. A valid URL does not establish account ownership. */
export function normalizeCompanySocialUrl(
  value: string | null | undefined,
  platform: 'instagram' | 'facebook',
): string | null {
  const input = value?.trim();
  if (!input) return null;
  const domain = `${platform}.com`;
  const handle = input.replace(/^@/, '');
  const candidate =
    /^[a-zA-Z0-9._]+$/.test(handle) &&
    ![
      'instagram.com',
      'www.instagram.com',
      'm.instagram.com',
      'facebook.com',
      'www.facebook.com',
      'm.facebook.com',
    ].includes(handle.toLowerCase())
      ? `https://${domain}/${handle}`
      : /^https?:\/\//i.test(input)
        ? input
        : `https://${input}`;
  let url: URL;
  try {
    url = new URL(candidate);
  } catch {
    throw new Error(`Informe um link ou @ válido do ${platform}.`);
  }
  if (
    !['http:', 'https:'].includes(url.protocol) ||
    ![domain, `www.${domain}`, `m.${domain}`].includes(url.hostname) ||
    url.username ||
    url.password ||
    url.port ||
    url.pathname === '/'
  ) {
    throw new Error(`Informe um link de perfil do ${platform}.`);
  }
  if (platform === 'instagram' && !/^\/[a-zA-Z0-9._]+\/?$/.test(url.pathname)) {
    throw new Error('Informe o perfil do Instagram, não uma publicação.');
  }
  const firstSegment = (url.pathname.split('/')[1] ?? '').toLowerCase();
  const reserved =
    platform === 'instagram'
      ? ['p', 'reel', 'reels', 'stories', 'explore', 'accounts', 'direct']
      : [
          'share',
          'sharer',
          'sharer.php',
          'dialog',
          'login',
          'login.php',
          'watch',
          'reel',
          'reels',
          'story.php',
          'photo.php',
          'plugins',
        ];
  if (reserved.includes(firstSegment)) throw new Error(`Informe um link de perfil do ${platform}.`);
  url.protocol = 'https:';
  url.hostname = domain;
  url.hash = '';
  const profileId = platform === 'facebook' && url.pathname === '/profile.php' ? url.searchParams.get('id') : null;
  url.search = '';
  if (url.pathname === '/profile.php') {
    if (!profileId || !/^\d+$/.test(profileId)) throw new Error('Informe um perfil válido do Facebook.');
    url.searchParams.set('id', profileId);
  }
  return url.toString();
}

/** Brazilian local numbers default to +55; explicit international numbers retain their country code. */
export function normalizeCompanyWhatsApp(value: string | null | undefined): string | null {
  const input = value?.trim();
  if (!input) return null;
  if (!/^\+?[\d\s().-]+$/.test(input)) throw new Error('Informe um número de WhatsApp válido.');
  let digits = input.replace(/\D/g, '');
  if (!input.startsWith('+')) {
    if (digits.length === 10 || digits.length === 11) digits = `55${digits}`;
    else if (!/^55\d{10,11}$/.test(digits)) throw new Error('Informe o WhatsApp com DDD e código do país.');
  }
  if (!/^[1-9]\d{7,14}$/.test(digits)) throw new Error('Informe o WhatsApp com DDD e código do país.');
  return `+${digits}`;
}
